import Field from "../../../components/ui/Field";
import { formatDate } from "../../../utils/date";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Profile.module.css";

const dateOrDash = (value) => (value ? formatDate(value) : "—");

// `client` is only set when the employee is deployed to a client.
const getClientName = (client) =>
  client?.clientName ?? client?.name ?? client?.code;

const EmploymentSection = ({ profile }) => {
  const separation = [
    { label: "Resignation", value: profile.resignationDate },
    { label: "Separation", value: profile.separationDate },
    { label: "Termination", value: profile.terminationDate },
  ].filter((item) => item.value);

  return (
    <>
      <h6 className={styles.sectionTitle}>Assignment</h6>
      <div className={ui.fieldGrid}>
        <Field label="Employee no.">{profile.employeeId}</Field>
        <Field label="Position">{profile.role?.title}</Field>
        <Field label="Status">{profile.employeeStatus}</Field>
        <Field label="Assignment type">{profile.assignmentType}</Field>
        <Field label="Seasonal">{profile.isSeasonal ? "Yes" : "No"}</Field>
        {profile.client && (
          <Field label="Client">{getClientName(profile.client)}</Field>
        )}
      </div>

      <h6 className={styles.sectionTitle}>Key dates</h6>
      <div className={ui.fieldGrid}>
        <Field label="Hiring date">{dateOrDash(profile.hiringDate)}</Field>
        <Field label="Probationary date">
          {dateOrDash(profile.probationaryDate)}
        </Field>
        <Field label="Regularization date">
          {dateOrDash(profile.regularizationDate)}
        </Field>
        {separation.map((item) => (
          <Field key={item.label} label={`${item.label} date`}>
            {formatDate(item.value)}
          </Field>
        ))}
      </div>
    </>
  );
};

export default EmploymentSection;
